import { Card, CardContent, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClick?: () => void;
  isSelected?: boolean;
  invalid?: boolean;
  cardSx?: SxProps<Theme>;
  cardContentSx?: SxProps<Theme>;
}

export const CardWithContent: FC<Props> = ({
  children,
  onClick,
  isSelected,
  invalid,
  cardSx,
  cardContentSx,
}) => {
  return (
    <Card
      onClick={invalid ? undefined : onClick}
      sx={{
        boxShadow: (theme: Theme) =>
          isSelected
            ? `0px 0px 0px 1px ${theme.palette.primary.main}`
            : `0px 0px 0px 1px ${theme.palette.divider}`,
        cursor: invalid ? 'not-allowed' : onClick ? 'pointer' : 'default',
        mb: 2,
        backgroundColor: (theme: Theme) =>
          invalid ? theme.palette.action.disabledBackground : 'inherit',
        ...(cardSx ?? {}),
      }}>
      <CardContent
        sx={{
          alignItems: 'center',
          display: 'flex',
          '&:last-child': { pb: 2 },
          p: 2,
          ...(cardContentSx ?? {}),
        }}>
        {children}
      </CardContent>
    </Card>
  );
};
